export default __webpack_public_path__ + "static/pulse_customer_greeting-4358cdd58786bc202c3dffb78ffce1ac.jpeg";